import { useState } from 'react'
import { Link } from 'react-router-dom'
import { CookieSettingsPanel } from '../ui/CookieBanner'

const communesPopulaires = [
  { nom: 'Paris', slug: 'paris' },
  { nom: 'Marseille', slug: 'marseille' },
  { nom: 'Lyon', slug: 'lyon' },
  { nom: 'Toulouse', slug: 'toulouse' },
  { nom: 'Nice', slug: 'nice' },
  { nom: 'Nantes', slug: 'nantes' },
  { nom: 'Bordeaux', slug: 'bordeaux' },
  { nom: 'Lille', slug: 'lille' },
]

export default function Footer() {
  const [cookieSettingsOpen, setCookieSettingsOpen] = useState(false)

  return (
    <footer className="py-12 bg-gray-900 text-gray-400 text-sm">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Communes populaires */}
        <div className="mb-8 pb-8 border-b border-gray-800">
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">PLU par commune</div>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            {communesPopulaires.map((c) => (
              <a key={c.slug} href={`/commune/${c.slug}`} className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">
                PLU {c.nom}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright + liens légaux */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <span>
              &copy; 2026 BonUrba —{' '}
              <a href="https://carteron-expertises.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors no-underline">
                Carex
              </a>
            </span>
            <a href="https://www.linkedin.com/showcase/bonurba" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors" aria-label="LinkedIn BonUrba">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
          <div className="flex gap-6 flex-wrap">
            <Link to="/mentions-legales" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">Mentions légales</Link>
            <Link to="/confidentialite" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">Confidentialité</Link>
            <Link to="/cgu" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">CGU</Link>
            <Link to="/glossaire" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">Glossaire</Link>
            <Link to="/guides" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">Guides</Link>
            <a href="https://carex.immo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">App CAREX</a>
            <Link to="/contact" className="text-gray-400 hover:text-green-400 transition-colors no-underline text-sm">Contact</Link>
            <button onClick={() => setCookieSettingsOpen(true)} className="text-gray-400 hover:text-green-400 transition-colors text-sm cursor-pointer">Gestion des cookies</button>
          </div>
        </div>
      </div>
      <CookieSettingsPanel open={cookieSettingsOpen} onClose={() => setCookieSettingsOpen(false)} />
    </footer>
  )
}
